import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RoleConstants } from '@app/@shared/constants/role.constant';
import { AuthenticationService } from '@app/services/authentication.service';
import { UserRolesService } from '@app/services/user-roles.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  userName: string = '';
  userRoles: string[] = [];
  partnerName: string = '';
  isLsAdmin: boolean = false;
  isDirEndUser: boolean = false;
  isLoggedIn: Boolean = false;
  version: string = '';
  partnerIsActive: boolean = true;
  isTestingPartner: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private userRolesService: UserRolesService,
    public constants: RoleConstants
  ) {
    this.authenticationService.isLoggedIn.subscribe((value) => {
      this.isLoggedIn = value;
    });

    this.authenticationService.selectedPartner.subscribe((data) => {
      if (data != null) {
        this.partnerName = data?.name;
        this.partnerIsActive = data?.isActive;

        this.isTestingPartner = [
          'Bedege AB',
          'K3 Business Solutions B.V.',
          'ArcherPoint, LLC',
          'RelateIT A/S',
          'Norsk Medisinaldepot AS',
          'LS Retail Internal Licenses - IS',
        ].includes(this.partnerName);
      } else {
        this.partnerName = '';
        this.partnerIsActive = true;
      }
    });
  }

  ngOnInit(): void {
    this.version = environment.version;

    this.authenticationService.currentUserSubject.subscribe((data) => {
      if (data == null) return;
      this.userRolesService.SetUser(data);
      this.userName = data?.fullname;
      this.userRoles = data?.roles;
      this.isLsAdmin = data?.isLsAdmin;
    });
    this.authenticationService.selectedPartner.subscribe((data) => {
      this.isDirEndUser = data?.isDirEnd;
    });
  }

  logoutClicked(event: Event): void {
    event.preventDefault();
    this.authenticationService.logout();
  }

  changeAccountClicked(event: Event): void {
    event.preventDefault();
    this.router.navigate(['select-partner']);
  }
}
